<template>
  <b-list-group-item class="mb-4" @click="setTarget(getRelItem, $event)" v-if="getRelItem">
    <div class="okrItem">
      <b-container class="container" :class="{ objective: (getRelItem.type === 'objective'), keyresult: (getRelItem.type === 'keyresult') }">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <span class="search-userimg">
              <img v-if="targetUserInfo.userIcon" :src="targetUserInfo.userIcon" alt="image" class="img-circle">
              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
            </span>
          </div>
          <div class="text-left item-center">
            <div class="search-userinfo">
              <span class="search-username">{{ targetUserInfo.userName }}</span>
              <span class="search-userdept">{{ targetUserInfo.dept }}</span>
            </div>
            <div :class="{ 'current-obj': getRelItem.type === 'objective' }" class="objective-text">
              <read-more :targetId="getRelItem.itemId" :text="getRelItem.contentText" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
                {{getRelItem.contentText}}
              </read-more>
            </div>
          </div>
          <div>
            <objective-knob :progress="getRelItem.progress" :readOnly="true" :width="40" :height="40" />
          </div>
        </div>
        <div class="item-bottom text-center small pt-2">
          <label class="mb-0">{{ $t('startDateStr') }}：</label>
          <span>{{getRelItem.startDate}}</span>
          </div>
        <div class="d-flex justify-content-between align-items-end">
          <b-btn variant="outline-warning" size="sm" @click="jump(getRelItem, getRelItem.type)" class="btn-open-detail">Jump</b-btn>
          <div class="mr-auto text-nowrap">
            <span><i class="fa fa-angle-double-left"></i></span>
            <b-badge pill variant="danger">{{ getRelItem.numRelationsDst }}</b-badge>
          </div>
          <div class="text-center small pt-2">
            <label class="mb-0">{{ $t('dueDateStr') }}：</label>
            <span>{{ getRelItem.dueDate }}</span>
          </div>
          <div class="ml-auto text-nowrap">
            <span v-if="getRelItem.isComplete" class="comp-label">{{$t('secStr')}}</span>
            <b-badge pill variant="danger">{{ getRelItem.numRelationsSrc }}</b-badge>
            <span><i class="fa fa-angle-double-left"></i></span>
          </div>
        </div>
      </b-container>
    </div>
  </b-list-group-item>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'

export default {
  name: 'ReportRelationsListOkrItem',
  components: {
    // moment,
    ObjectiveKnob,
    ReadMore
  },
  props: ['relItem', 'dir', 'fromDate', 'toDate'], // 絞り込む時にtoDateは現状は指定されていない
  data: function () {
    return {
      propShowMore: false,
      propContentHeight: 0
      // targetUser: this.$store.state.currentUserId,
      // progress: 0
    }
  },
  getters: {
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('objectives', [
      'getObjectiveById',
      'getObjectives'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultById',
      'getKeyresults'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getRelItem () {
      let key = {
        type: 'unknown',
        userId: '',
        key: '',
        ...this.relItem
      }
      console.log('getRelItem', this.relItem, key)
      let ret = {}
      switch (key.type) {
        case 'objectives':
          ret = ((this.getObjectives[key.userId] || {})[key.key] || {})
          ret.owner = key.userId
          break
        case 'keyresults':
          ret = ((this.getKeyresults[key.userId] || {})[key.key] || {})
          ret.owner = key.userId
          break
        default:
          break
      }
      // console.log(ret)
      if (!this.itemIsVisible(ret)) {
        console.log('* boo!')
        return false
      }
      ret.type = key.type
      ret.userId = key.userId
      ret.itemId = key.key
      ret.progress = Number(ret.progress)
      if (isNaN(ret.progress)) {
        ret.progress = 0
      }
      ret.date = moment(ret.createdAt * 1000).format('YYYY-MM-DD')
      let relsObj = Object.keys(ret.relations || {})
      let chkRelsObjKeys = {}
      ret.numRelations = relsObj.length
      ret.numRelationsSrc = 0
      ret.numRelationsDst = 0
      for (let relObjKey of relsObj) {
        let rel = ret.relations[relObjKey]
        if (!this.isBetweenDate(rel)) continue
        // console.log('ListRelItem:relObjs: ' + relObjKey, rel)
        if (!this.relItemIsVisible(rel)) {
          console.log('* Boo! Ignored rel.', rel)
          continue
        }
        let chkRelsObjKey = [rel.type, rel.userId, rel.key].join('_')
        if (relObjKey === '.key' || chkRelsObjKeys[chkRelsObjKey]) {
          console.log('* Boo! Ignored rel.:Duplicated', rel)
          continue
        }
        if (!!rel.dir && rel.dir === 'src') {
          ret.numRelationsSrc++
        } else {
          ret.numRelationsDst++
        }
        chkRelsObjKeys[chkRelsObjKey] = true
      }
      console.log('getRelItem:ret', ret)
      return ret
    },
    targetUserInfo () {
      return {
        userName: '（ユーザ名取得中）',
        userIcon: null,
        ...this.getUserInfoById(this.relItem.userId)
      }
    }
  },
  created: function () {
  },
  methods: {
    setTarget (val, ev) {
      console.log('setTarget: ', this.relItem, val, ev, ev.target.className)
      if (ev.target.className !== 'd-open cursor') {
        this.$emit('set-target', val, ev)
      }
    },
    jump: function (value, itemType) {
      console.log(' this.$emit(get-detail)', value, itemType)
      if (itemType) {
        itemType = itemType.replace(/^(objective|keyresult)$/, '$1s')
        value.type = {}
        value.type[itemType] = value.itemId || ''
      }
      this.$emit('open-detail', value)
    },
    isBetweenDate (item) {
      let date
      if (!item.dueDate) {
        switch (item.type) {
          case 'objectives':
            date = this.getObjectiveById(item.key, item.userId).dueDate
            break
          case 'keyresults':
            date = this.getKeyresultById(item.key, item.userId).dueDate
            break
        }
      } else {
        date = item.dueDate
      }
      date = date + ' 23:59:59'
      return (
        Date.parse(this.fromDate) <= Date.parse(date) /* &&
        Date.parse(date) <= Date.parse(this.toDate) */
      )
    },
    relItemIsVisible: function (key) {
      // const rel = this.getObjectivesByUserId(key)
      let rel
      switch ((key || {}).type) {
        case 'objectives':
          rel = this.getObjectiveById(key.key, key.userId)
          rel.owner = key.userId
          break
        case 'keyresults':
          rel = this.getKeyresultById(key.key, key.userId)
          rel.owner = key.userId
          break
        default:
          console.log('ListRelItem:relItemIsVisible: Unknown type.')
          return false
      }
      // console.log('ListRelItem:relItemIsVisible:', key, rel)
      return Object.keys(rel).length ? this.itemIsVisible(rel) : false
    },
    itemIsVisible: function (item) {
      const me = this.getCurrentUser
      const meId = this.getUserId
      console.log('isVisible?:', item, me, meId)
      if (item) {
        if (item.hasOwnProperty('owner') && (item.owner === meId)) {
          console.log('isVisible: true, owner')
          return true
        }
        if (!item.hasOwnProperty('limitedAccess')) {
          console.log('isVisible: true, no limited')
          return true
        }
        if (item.limitedAccess.hasOwnProperty('limitedUsers')) {
          console.log('!isVisible: has users')
          if (item.limitedAccess.limitedUsers.hasOwnProperty(this.getUserId)) {
            console.log('isVisible: me in users')
            return true
          }
        }
        if (item.limitedAccess.hasOwnProperty('limitedGroups')) {
          console.log('!isVisible: has group')
          if (me.hasOwnProperty('groups')) {
            console.log('isVisible: me in group')
            return Object.keys(item.limitedAccess.limitedGroups).some(x => me.groups.hasOwnProperty(x))
          }
        }
      }
      return false
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      // console.log('in objective updateContentHeight::', value)
      this.propContentHeight = value
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a:hover{
  text-decoration: none;
}
.okrItem {
  transition: .2s;
  // font-size: 75%;
  .container {
    padding: 0;
    cursor: pointer;
    transition: .2s;
    .btn-open-detail {
      display: none;
      position: absolute;
      // right: 1.2em;
      bottom: 2.1em;
      z-index: 999;
    }
    &:hover {
      transition: .2s;
      .btn-open-detail {
        display: block;
        &:not(:hover) {
          background-color: rgba(255,255,255,.7)
        }
      }
    }
    .search-userinfo {
      span {
        display: inline-block;
        padding-left: .25em;
      }
    }
  }
  .objective {
    display: block;
    box-shadow: 0 0 .1em .3em transparent;
    &:hover {
      box-shadow: 0 0 .1em .3em #333399;
    }
  }
  .keyresult {
    padding-left: 1em;
    box-shadow: 0 0 .1em .3em transparent;
    &:hover {
      box-shadow: 0 0 .1em .3em #6666ff;
    }
  }
  .objective-text {
    margin-left: 0;
  }
  .content-text {
    // margin-bottom: 0;
    padding-left: .5em;
    padding-right: .5em;
  }
  .item-bottom {
    margin-top: 0.5em;
    border-top: 1px dotted rgba(0, 0, 0, 0.1);
  }
  .item-center {
    flex-grow: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportRelationsListRelItem.vue